<app-logiciel-caisse-list-toolbar
  [(searchTerm)]="searchTerm"
  (searchTermChange)="applySearch()"
  primaryLabel="+ Nouvel entrepôt"
  (primaryClick)="openCreate(entrepotModal)"
></app-logiciel-caisse-list-toolbar>

<div class="table-full-width">
    <div class="table-responsive lc-table-scroll">
      <table class="table table-hover pos-ticket-table">
        <thead class="custom-header">
          <tr>
            <th>Code</th>
            <th>Libellé</th>
            <th>Ville</th>
            <th>Pays</th>
            <th>Priorité</th>
            <th>Caisses associées</th>
            <th style="width: 120px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading" class="lc-loading-row">
            <td colspan="7">
              <span class="spinner-border spinner-border-sm mr-1"></span>
              Chargement des entrepôts…
            </td>
          </tr>
          <tr *ngFor="let row of filteredRows" [hidden]="loading">
            <td>{{ rowCode(row) }}</td>
            <td>{{ rowLibelle(row) }}</td>
            <td>{{ row.VILLE }}</td>
            <td>{{ row.PAYS }}</td>
            <td>{{ rowPriorite(row) }}</td>
            <td>{{ caissesSummary(row) }}</td>
            <td class="d-flex align-items-center flex-nowrap">
              <button
                type="button"
                class="btn btn-sm btn-icon btn-outline-primary mr-50"
                title="Modifier"
                (click)="openEdit(row, entrepotModal)"
              >
                <i data-feather="edit" [size]="16"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-outline-primary"
                title="Caisses associées"
                (click)="openAssociation(row, assocModal)"
              >
                <i data-feather="link" [size]="16"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">
            <td colspan="7">Pas de données à afficher</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

<ng-template #entrepotModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ editId ? 'Modifier' : 'Créer' }} entrepôt</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body" [formGroup]="form">
    <div class="form-group">
      <label>Libellé</label>
      <input class="form-control" formControlName="libelle" />
    </div>
    <div class="form-group">
      <label>Code entrepôt</label>
      <input class="form-control" formControlName="code_entrepot" />
    </div>
    <div class="form-group">
      <label>Ville</label>
      <input class="form-control" formControlName="ville" />
    </div>
    <div class="form-group">
      <label>Pays</label>
      <input class="form-control" formControlName="pays" />
    </div>
    <div class="custom-control custom-checkbox mb-1">
      <input type="checkbox" class="custom-control-input" id="is_reassort" formControlName="is_reassort" />
      <label class="custom-control-label" for="is_reassort">Réassort</label>
    </div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="is_globale" formControlName="is_globale" />
      <label class="custom-control-label" for="is_globale">Globale</label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-primary" (click)="save(modal)" [disabled]="saving || form.invalid">
      Enregistrer
    </button>
  </div>
</ng-template>

<ng-template #assocModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Association entrepôt / caisses</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-2" *ngIf="associationRow">
      Entrepôt :
      <strong>{{ rowLibelle(associationRow) }}</strong>
      <span class="text-muted">({{ rowCode(associationRow) }})</span>
    </p>
    <p class="text-muted small mb-3">
      Sélectionnez les caisses disponibles de la station à rattacher à cet entrepôt.
      Une caisse ne peut être rattachée qu'à un seul entrepôt.
    </p>
    <div class="form-group mb-2">
      <label>Caisses</label>
      <ng-select
        [items]="caisseOptions"
        bindLabel="label"
        bindValue="id"
        [multiple]="true"
        [closeOnSelect]="false"
        placeholder="Sélectionner des caisses"
        [(ngModel)]="associationCaisseIds"
      ></ng-select>
    </div>
    <button
      type="button"
      class="btn btn-sm btn-outline-primary"
      (click)="createCaisseForAssociation()"
      [disabled]="creatingCaisse"
    >
      + Nouvelle caisse sur cet entrepôt
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="saveAssociation(modal)"
      [disabled]="associationSaving"
    >
      Enregistrer
    </button>
  </div>
</ng-template>
